module.exports = __webpack_public_path__ + "static/media/Plain credit card.dc04e29a.png";